<template>
  <div class="max-racing-animation-container" style="height:300px;">
    <img class="roadImg roadMove" src=https://i.ibb.co/FH9MV9z/roadv6.png>
    <div class="allCarContainer">
      <div class="car1" ref="car1">
        <img class="car carOne" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car2">
        <img class="car carTwo" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car3">
        <img class="car carThree" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car4">
        <img class="car carFour" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car5">
        <img class="car carFive" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car6">
        <img class="car carSix" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car7">
        <img class="car carSeven" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car1" ref="car8">
        <img class="car carEight" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car9" ref="car9">
        <img class="car carNine" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
      <div class="car10" ref="car10">
        <img class="car carTen" src="https://i.ibb.co/xgDfbL9/spr-car7.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite, TimelineLite } from "gsap";

let car1 = new TimelineLite();

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "game-on-animation-end"
  ],
  components: {},
  data() {
    return {
      car1: -100,
      car2: -120,
      car3: -60,
      car4: -90,
      car5: -50,
      car6: -100,
      car7: -70,
      car8: -95,
      car9: -90,
      car10: -70,
      isNegative: 1,
      winner: [],
      counter: 0
    };
  },
  watch: {
    drawResult() {
      this.counter++;
      //   console.log(this.drawResult);
      this.winner = this.drawResult.champion.split(",");
      if (this.counter > 1) {
        document.getElementsByClassName("roadMove")[0].style.animationName = "";
        TweenLite.to(this.$refs["car" + this.winner[0]], 1, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[1]], 1.2, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[2]], 1.4, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[3]], 1.6, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[4]], 1.8, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[5]], 2, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[6]], 2.2, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[7]], 2.4, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[8]], 2.6, { x: -380 });
        TweenLite.to(this.$refs["car" + this.winner[9]], 2.8, { x: -380 });

        // console.log(this.winner);
        this.animationEnd();
      }
    },
    disallowBetting() {
      if (this.disallowBetting) {
        document.getElementsByClassName("roadMove")[0].style.animationName =
          "roadMoveplaybox";

        let vm = this;
        setTimeout(() => {
          this.increment();
        }, 3000);

        TweenLite.to(vm.$refs["car1"], 2, { x: this.car1 });
        TweenLite.to(vm.$refs["car2"], 2, { x: this.car2 });
        TweenLite.to(vm.$refs["car3"], 2, { x: this.car3 });
        TweenLite.to(vm.$refs["car4"], 2, { x: this.car4 });
        TweenLite.to(vm.$refs["car5"], 2, { x: this.car5 });
        TweenLite.to(vm.$refs["car6"], 2, { x: this.car6 });
        TweenLite.to(vm.$refs["car7"], 2, { x: this.car7 });
        TweenLite.to(vm.$refs["car8"], 2, { x: this.car8 });
        TweenLite.to(vm.$refs["car9"], 2, { x: this.car9 });
        TweenLite.to(vm.$refs["car10"], 2, { x: this.car10 });
      }
    }
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
    getRandNeInt() {
      this.isNegative = 1;
      return Math.floor(Math.random() * 50) - 80;
    },
    getRandInt() {
      this.isNegative = 0;
      return Math.floor(Math.random() * 100 - 20);
    },
    increment() {
      this.car1 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car1"], 6, { x: this.car1 });

      this.car2 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car2"], 6, { x: this.car2 });

      this.car3 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car3"], 6, { x: this.car3 });

      this.car4 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car4"], 6, { x: this.car4 });

      this.car5 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car5"], 6, { x: this.car5 });

      this.car6 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car6"], 6, { x: this.car6 });

      this.car7 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car7"], 6, { x: this.car7 });

      this.car8 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car8"], 6, { x: this.car8 });

      this.car9 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car9"], 6, { x: this.car9 });

      this.car10 +=
        this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
      TweenLite.to(this.$refs["car10"], 4, { x: this.car10 });

      this.isNegative > 0 ? this.getRandInt() : this.getRandNeInt();
    }
  },
  mounted() {
    // console.log(document.getElementsByClassName("roadMove"));
    // console.log(this.gameData);
    // console.log("disallowBetting");
    // console.log(this.disallowBetting);
  }
};
</script>

<style lang="scss">
@keyframes roadMoveplaybox {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(320px);
  }
}
</style>

<style lang="scss" scoped>
.max-racing-animation-container {
  overflow: hidden;
  position: relative;
}

.roadImg {
  right: 0;
  bottom: 0;
  width: 1000px;
  height: 300px;
  position: absolute;
}

.roadMove {
  //   animation-name: roadMoveplaybox;
  animation-delay: 0ms;
  animation-duration: 600ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.max-racing-animation-container > div > div {
  position: relative;
  display: block;
  width: 100%;
  height: 30px;
}

.car {
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  bottom: 0;
}
.carOne {
  right: 4px;
  height: 24px;
  width: 62px;
}

.carTwo {
  right: 4px;
  height: 25px;
  width: 66px;
}

.carThree {
  right: 4px;
  height: 26px;
  width: 68px;
}

.carFour {
  right: 5px;
  height: 27px;
  width: 68px;
}

.carFive {
  right: 6px;
  height: 27px;
  width: 69px;
}

.carSix {
  top: -1px;
  right: 6px;
  height: 28px;
  width: 72px;
}

.carSeven {
  top: -1px;
  right: 6px;
  height: 31px;
  width: 74px;
}

.carEight {
  top: -1px;
  right: 6px;
  height: 31px;
  width: 77px;
}

.carNine {
  top: -1px;
  right: 5px;
  height: 32px;
  width: 82px;
}

.carTen {
  top: -1px;
  right: 5px;
  height: 33px;
  width: 85px;
}
</style>